export default "__VITE_ASSET__WKl5qDsZ__"